import { Views } from '~/types';
import { Dashboards } from '~/pages/Dashboards';

export const viewRoutes = [
    {
        id: Views.Dashboards,
        component: Dashboards,
    },
];
